import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WhitelabeledComponentKey } from '../../../../../../whitelabel/whitelabel-component-types';
import { SidebarState } from '../../../../../osp-ui/components/sidebar/contract/sidebar-state.contract';
import { BaseSidebarStateDirective } from '../../../../../osp-ui/components/sidebar/directives/base-sidebar-state.directive';
import { WhitelabeledComponent } from '../../../../../whitelabel/components/whitelabeled-component/whitelabeled-component.component';
import { SidebarWrapperComponent } from '../../sidebar/sidebar-wrapper.component';
import { TopbarComponent } from '../../topbar/topbar.component';

@Component({
  selector: 'osp-default-dashboard-layout',
  standalone: true,
  imports: [WhitelabeledComponent, TopbarComponent, NgClass, RouterOutlet],
  templateUrl: './default-dashboard-layout.component.html',
  styleUrl: './default-dashboard-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultDashboardLayoutComponent {
  $sidebarState = signal(BaseSidebarStateDirective.DEFAULT_STATE);
  sidebarProps = {
    registerOnStateChange: (state: SidebarState) => this.$sidebarState.set(state),
  };

  protected readonly WhitelabeledComponentKey = WhitelabeledComponentKey;
  protected readonly SidebarComponent = SidebarWrapperComponent;
}
